import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 翻译资源
const resources = {
  en: {
    translation: {
      // Common
      "connect": "Connect",
      "disconnect": "Disconnect",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "refresh": "Refresh",
      "configure": "Configure",
      "yes": "Yes",
      "no": "No",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "loading": "Loading...",
      "success": "Success",
      "error": "Error",
      "warning": "Warning",
      
      // Menu
      "menu.home": "Overview",
      "menu.applets": "Applets",
      "menu.fido2": "FIDO2",
      "menu.admin": "Admin",
      "menu.oath": "OATH",
      "menu.openpgp": "OpenPGP",
      "menu.piv": "PIV",
      "menu.pass": "PASS",
      "menu.ndef": "NDEF",
      "menu.apdu": "APDU Console & History",
      "menu.browserCheck": "Browser Compatibility",
      "menu.setupWizard": "Setup Wizard",
      "menu.pinRecovery": "PIN Recovery",
      "menu.compatibilityReport": "Compatibility Report",

      // Overview
      "overview.title": "GriffonOakey Web Console",
      "overview.device_status": "Device Status",
      "overview.connected": "Connected",
      "overview.disconnected": "Disconnected",
      "overview.model": "Model",
      "overview.serial": "Serial Number",
      "overview.chip_id": "Chip ID",
      "overview.firmware": "Firmware Version",
      "overview.quick_nav": "Quick Navigation",
      "overview.go_to": "Go to",
      
      // Admin
      "admin.title": "Admin",
      "admin.authentication": "Authentication",
      "admin.pin": "PIN",
      "admin.change_pin": "Change PIN",
      "admin.storage": "Storage",
      "admin.led": "LED",
      "admin.ndef": "NDEF",
      "admin.webusb": "WebUSB",
      "admin.reset": "Reset",
      "admin.firmware_update": "Firmware Update",
      
      // FIDO2
      "fido2.title": "FIDO2",
      "fido2.credentials": "Credentials",
      "fido2.pin_management": "PIN Management",
      
      // OATH
      "oath.title": "OATH",
      "oath.add_credential": "Add Credential",
      "oath.credentials": "Credentials",
      
      // OpenPGP
      "openpgp.title": "OpenPGP",
      "openpgp.key_management": "Key Management",
      
      // PIV
      "piv.title": "PIV",
      "piv.certificate": "Certificate",
      "piv.key_management": "Key Management",
      
      // PASS
      "pass.title": "PASS - Password Manager",
      "pass.description": "Configure touch button to automatically type passwords. Two slots are available: short press and long press.",
      "pass.short_press": "Short Press",
      "pass.long_press": "Long Press",
      "pass.slot": "Slot",
      "pass.type": "Slot Type",
      "pass.type.disabled": "Disabled",
      "pass.type.static": "Static Password",
      "pass.type.oath": "OATH (Dynamic)",
      "pass.password": "Password",
      "pass.credential": "Credential",
      "pass.auto_enter": "Auto Enter",
      "pass.auto_enter_help": "Automatically press Enter after typing",
      "pass.configure_slot": "Configure {{slot}} Slot",
      "pass.reset": "Reset PASS",
      "pass.reset_confirm": "Are you sure you want to reset PASS applet? This will clear all password slots.",
      "pass.password_hidden": "••••••••",
      "pass.max_length": "Max {{length}} characters",
      
      // NDEF
      "ndef.title": "NDEF - NFC Data Exchange",
      "ndef.description": "Manage NFC NDEF messages and tags. Configure what data your device broadcasts via NFC.",
      "ndef.current_message": "Current NDEF Message",
      "ndef.message_type": "Message Type",
      "ndef.url": "URL",
      "ndef.text": "Text",
      "ndef.custom": "Custom",
      "ndef.readonly": "Read Only",
      "ndef.readonly_help": "When enabled, NDEF data cannot be modified",
      "ndef.message_content": "Message Content",
      "ndef.url_address": "URL Address",
      "ndef.text_content": "Text Content",
      "ndef.language": "Language",
      "ndef.encoding": "Encoding",
      "ndef.hex_data": "Hex Data",
      "ndef.write_message": "Write NDEF Message",
      "ndef.read_message": "Read NDEF Message",
      "ndef.reset": "Reset NDEF",
      "ndef.reset_confirm": "Are you sure you want to reset NDEF? This will restore default NFC data.",
      "ndef.max_size": "Maximum message size: 1022 bytes",
      "ndef.current_size": "Current size: {{size}} bytes",
      
      // Messages
      "msg.device_not_connected": "Device not connected",
      "msg.please_connect": "Please connect your device first",
      "msg.operation_success": "Operation completed successfully",
      "msg.operation_failed": "Operation failed",
      "msg.invalid_input": "Invalid input",
      "msg.confirm_action": "Are you sure you want to proceed?",

      // WebUSB
      "webusb.notSupported": "Your browser does not support WebUSB. Please use Chrome, Edge, or Opera.",
      "webusb.supported": "Your browser supports WebUSB. You're good to go!",
      "webusb.viewDetails": "View Details",
      "webusb.downloadChrome": "Download Chrome",

      // Browser Compatibility Check
      "browserCheck.title": "Browser Compatibility Check",
      "browserCheck.status.supported": "✓ Browser Supports WebUSB",
      "browserCheck.status.notSupported": "✗ Browser Does Not Support WebUSB",
      "browserCheck.status.supportedDesc": "Your browser supports WebUSB API and can use all features.",
      "browserCheck.status.notSupportedDesc": "Your browser does not support WebUSB API and cannot connect to USB devices. Please use a recommended browser.",
      "browserCheck.currentBrowser": "Current Browser Information",
      "browserCheck.browserName": "Browser",
      "browserCheck.browserVersion": "Version",
      "browserCheck.support": "Support",
      "browserCheck.supported": "Supported",
      "browserCheck.notSupported": "Not Supported",
      "browserCheck.supportedBrowsers": "Supported Browsers",
      "browserCheck.recommended": "Recommended",
      "browserCheck.download": "Download",
      "browserCheck.chrome.version": "Version 61 and above (Recommended)",
      "browserCheck.edge.version": "Version 79 and above",
      "browserCheck.opera.version": "Version 48 and above",
      "browserCheck.firefox.reason": "Not supported (Mozilla official position: Negative)",
      "browserCheck.safari.reason": "Not supported (Apple official position: Oppose)",
      "browserCheck.whyNotSupported.title": "Why Firefox and Safari Don't Support WebUSB?",
      "browserCheck.whyNotSupported.security": "Security concerns: WebUSB allows web pages to directly access USB devices, posing potential security risks",
      "browserCheck.whyNotSupported.privacy": "Privacy issues: Could be used for device fingerprinting and user tracking",
      "browserCheck.whyNotSupported.architecture": "Architecture limitations: Conflicts with browser security models",
      "browserCheck.requirements.title": "WebUSB Requirements",
      "browserCheck.requirements.https": "Must use HTTPS (secure context)",
      "browserCheck.requirements.userGesture": "Requires user gesture to initiate connection",
      "browserCheck.requirements.devicePermission": "User must grant device access permission",

      // Common actions
      "common.back": "Back",
      "common.next": "Next",

      // Setup Wizard
      "setupWizard.title": "Setup Wizard",
      "setupWizard.step1": "Device Detection",
      "setupWizard.step2": "PIN Setup",
      "setupWizard.step3": "Feature Selection",
      "setupWizard.step4": "Testing",
      "setupWizard.step5": "Complete",
      "setupWizard.welcome": "Welcome to Setup Wizard",
      "setupWizard.welcomeDesc": "This wizard will guide you through the initial setup of your device in 5 minutes.",
      "setupWizard.whatYouNeed": "What You Need",
      "setupWizard.need1": "Your device connected via USB",
      "setupWizard.need2": "5 minutes of time",
      "setupWizard.need3": "Recovery code card (to write down the code)",
      "setupWizard.deviceReady": "Device detected and ready",
      "setupWizard.setupPins": "Set Up PIN Codes",
      "setupWizard.pinsDesc": "Set up User PIN and Admin PIN to protect your device.",
      "setupWizard.userPinSection": "User PIN",
      "setupWizard.userPin": "User PIN",
      "setupWizard.confirmUserPin": "Confirm User PIN",
      "setupWizard.userPinHelper": "6-8 digits for daily use",
      "setupWizard.adminPinSection": "Admin PIN",
      "setupWizard.adminPin": "Admin PIN",
      "setupWizard.confirmAdminPin": "Confirm Admin PIN",
      "setupWizard.adminPinHelper": "8 digits for device management",
      "setupWizard.selectFeatures": "Select Features",
      "setupWizard.featuresDesc": "Choose which features to enable on your device.",
      "setupWizard.recommended": "Recommended",
      "setupWizard.fido2Desc": "For website two-factor authentication",
      "setupWizard.pivDesc": "For enterprise authentication and Windows login",
      "setupWizard.openpgpDesc": "For email encryption and code signing",
      "setupWizard.oathDesc": "For generating verification codes",
      "setupWizard.testing": "Testing Device",
      "setupWizard.testingDesc": "Running tests to ensure everything works correctly.",
      "setupWizard.testUsb": "USB Communication Test",
      "setupWizard.testNfc": "NFC Functionality Test",
      "setupWizard.testFido2": "FIDO2 Functionality Test",
      "setupWizard.testPiv": "PIV Smart Card Test",
      "setupWizard.testOpenPGP": "OpenPGP Functionality Test",
      "setupWizard.testOath": "OATH (TOTP/HOTP) Test",
      "setupWizard.complete": "Setup Complete!",
      "setupWizard.completeDesc": "Your device is now ready to use.",
      "setupWizard.nextSteps": "Next Steps",
      "setupWizard.next1": "Add your device to websites (Google, GitHub, etc.)",
      "setupWizard.next2": "Write down your recovery code and keep it safe",
      "setupWizard.next3": "Explore other features in the console",
      "setupWizard.runTests": "Run Tests",
      "setupWizard.error.noDevice": "No device connected",
      "setupWizard.error.deviceCheck": "Failed to check device",
      "setupWizard.error.invalidUserPin": "User PIN must be 6-8 digits",
      "setupWizard.error.userPinMismatch": "User PINs do not match",
      "setupWizard.error.invalidAdminPin": "Admin PIN must be 8 digits",
      "setupWizard.error.adminPinMismatch": "Admin PINs do not match",
      "setupWizard.error.samePins": "User PIN and Admin PIN must be different",
      "setupWizard.error.pinSetup": "Failed to set up PINs",
      "setupWizard.error.wrongPin": "Wrong PIN, {{retries}} retries left",
      "setupWizard.error.pinBlocked": "PIN is blocked",
      "setupWizard.error.defaultPinFailed": "Default PIN verification failed - device may already be initialized",
      "setupWizard.error.adminPinChangeFailed": "Failed to change Admin PIN",
      "setupWizard.error.featureConfig": "Failed to configure features",
      "setupWizard.error.tests": "Tests failed",
      "setupWizard.error.usbTestFailed": "USB communication test failed - please check device connection",
      "setupWizard.error.fido2TestFailed": "FIDO2 test failed - applet may not be enabled",
      "setupWizard.error.pivTestFailed": "PIV test failed - applet may not be enabled",
      "setupWizard.error.openpgpTestFailed": "OpenPGP test failed - applet may not be enabled",
      "setupWizard.error.oathTestFailed": "OATH test failed - applet may not be enabled",
      "setupWizard.error.deviceDisconnected": "Device disconnected - please reconnect and start over",
      "setupWizard.deviceDetected": "Device detected successfully",
      "setupWizard.pinsSet": "PINs set successfully",
      "setupWizard.autoLoginSuccess": "Automatically logged in with new PIN",
      "setupWizard.featuresConfigured": "Features configured successfully",
      "setupWizard.testsComplete": "All tests passed",
      "setupWizard.deviceAutoConnected": "Device connected automatically",
      "setupWizard.deviceConnected": "Device connected - ready to proceed",
      "setupWizard.noDeviceHint": "No device detected. Click 'Next' to select and connect your device.",
      "setupWizard.defaultPinDetected": "Device is using default PIN - please set up your custom PINs",
      "setupWizard.alreadyInitialized": "Device appears to be already initialized. If you continue, you will overwrite existing PINs.",

      // Overview
      "overview.setupWizardTitle": "First Time Setup Required",
      "overview.setupWizardMessage": "Your device is using the default PIN (123456). For security reasons, it is strongly recommended to change it immediately.",
      "overview.setupWizardWarning": "Default PINs are publicly known and make your device vulnerable to unauthorized access.",
      "overview.setupNow": "Setup Now",
      "overview.setupLater": "Remind Me Later",
      "overview.setupLaterReminder": "Please remember to change your PIN as soon as possible for security",

      // PIN Recovery
      "pinRecovery.title": "PIN Recovery",
      "pinRecovery.step1": "Introduction",
      "pinRecovery.step2": "Check Status",
      "pinRecovery.step3": "Reset PIN",
      "pinRecovery.step4": "Complete",
      "pinRecovery.welcome": "Welcome to PIN Recovery",
      "pinRecovery.welcomeDesc": "This tool helps you reset your PIN using the recovery code.",
      "pinRecovery.warning": "Warning: Recovery code can only be used once. After use, you must generate a new recovery code.",
      "pinRecovery.requirements": "Requirements:",
      "pinRecovery.req1": "Your device connected via USB",
      "pinRecovery.req2": "8-character recovery code",
      "pinRecovery.req3": "New PIN code (6-8 digits)",
      "pinRecovery.statusCheck": "Recovery Code Status",
      "pinRecovery.currentStatus": "Current Status",
      "pinRecovery.status.unused": "Available (can be used)",
      "pinRecovery.status.used": "Used (need to generate new code)",
      "pinRecovery.status.locked": "Locked (too many attempts)",
      "pinRecovery.canProceed": "Recovery code is available. You can proceed to reset your PIN.",
      "pinRecovery.codeUsed": "Recovery code has been used. Please generate a new recovery code first.",
      "pinRecovery.codeLocked": "Recovery code is locked due to too many failed attempts. Please contact support.",
      "pinRecovery.enterDetails": "Enter Recovery Details",
      "pinRecovery.pinType": "PIN Type",
      "pinRecovery.userPin": "User PIN",
      "pinRecovery.adminPin": "Admin PIN",
      "pinRecovery.recoveryCode": "Recovery Code",
      "pinRecovery.codeHelper": "8 characters from your recovery card",
      "pinRecovery.newPin": "New PIN",
      "pinRecovery.confirmPin": "Confirm New PIN",
      "pinRecovery.pinHelper": "6-8 digits",
      "pinRecovery.resetWarning": "After resetting, you must generate a new recovery code immediately.",
      "pinRecovery.resetPin": "Reset PIN",
      "pinRecovery.complete": "PIN Reset Complete!",
      "pinRecovery.completeDesc": "Your PIN has been successfully reset.",
      "pinRecovery.nextSteps": "Important Next Steps",
      "pinRecovery.next1": "Generate a new recovery code immediately",
      "pinRecovery.next2": "Write down the new recovery code on your card",
      "pinRecovery.next3": "Test your new PIN to ensure it works",
      "pinRecovery.resetAnother": "Reset Another PIN",
      "pinRecovery.help": "Help",
      "pinRecovery.q1": "Q: What if I lost my recovery code?",
      "pinRecovery.a1": "A: Unfortunately, without the recovery code, you cannot reset your PIN. You will need to reset the entire device, which will erase all data.",
      "pinRecovery.q2": "Q: Can I use the same recovery code multiple times?",
      "pinRecovery.a2": "A: No, each recovery code can only be used once. After use, you must generate a new one.",
      "pinRecovery.q3": "Q: How do I generate a new recovery code?",
      "pinRecovery.a3": "A: Go to Admin section and select 'Generate Recovery Code'.",
      "pinRecovery.error.noDevice": "No device connected",
      "pinRecovery.error.checkFailed": "Failed to check recovery code status",
      "pinRecovery.error.invalidCode": "Recovery code must be 8 characters",
      "pinRecovery.error.invalidPin": "PIN must be 6-8 digits",
      "pinRecovery.error.pinMismatch": "PINs do not match",
      "pinRecovery.error.invalidCodeOrUsed": "Invalid recovery code or already used",
      "pinRecovery.error.resetFailed": "Failed to reset PIN",
      "pinRecovery.success": "PIN reset successfully",

      // Compatibility Report
      "compatibility.title": "Submit Compatibility Report",
      "compatibility.description": "Help other users by sharing your experience with websites and services.",
      "compatibility.websiteInfo": "Website Information",
      "compatibility.websiteName": "Website Name",
      "compatibility.websiteUrl": "Website URL",
      "compatibility.category": "Category",
      "compatibility.supportStatus": "Support Status",
      "compatibility.support": "Support",
      "compatibility.full": "Full Support",
      "compatibility.partial": "Partial Support",
      "compatibility.none": "No Support",
      "compatibility.yes": "Yes",
      "compatibility.no": "No",
      "compatibility.unknown": "Unknown",
      "compatibility.testResult": "Test Result",
      "compatibility.testResultLabel": "Did it work?",
      "compatibility.working": "Working",
      "compatibility.notWorking": "Not Working",
      "compatibility.partialWork": "Partially Working",
      "compatibility.issues": "Issues Encountered",
      "compatibility.issuesPlaceholder": "Describe any problems you encountered...",
      "compatibility.setupSteps": "Setup Steps",
      "compatibility.setupStepsPlaceholder": "1. Go to...\n2. Click...\n3. ...",
      "compatibility.environment": "Device & Environment",
      "compatibility.deviceModel": "Device Model",
      "compatibility.browserVersion": "Browser & Version",
      "compatibility.notes": "Additional Notes",
      "compatibility.notesPlaceholder": "Any other information that might be helpful...",
      "compatibility.submit": "Submit Report",
      "compatibility.tips": "Tips for Submitting",
      "compatibility.tip1": "Be specific about the steps you followed",
      "compatibility.tip2": "Include any error messages you saw",
      "compatibility.tip3": "Mention your operating system if relevant",
      "compatibility.thankYou": "Thank You!",
      "compatibility.submitted": "Your compatibility report has been submitted successfully.",
      "compatibility.error.required": "Please fill in all required fields",
      "compatibility.error.submit": "Failed to submit report",
      "compatibility.success": "Report submitted successfully",
    }
  },
  zh: {
    translation: {
      // Common - 通用
      "connect": "连接",
      "disconnect": "断开连接",
      "save": "保存",
      "cancel": "取消",
      "delete": "删除",
      "edit": "编辑",
      "add": "添加",
      "refresh": "刷新",
      "configure": "配置",
      "yes": "是",
      "no": "否",
      "enabled": "已启用",
      "disabled": "已禁用",
      "loading": "加载中...",
      "success": "成功",
      "error": "错误",
      "warning": "警告",
      
      // Menu - 菜单
      "menu.home": "概览",
      "menu.applets": "应用",
      "menu.fido2": "FIDO2",
      "menu.admin": "管理",
      "menu.oath": "OATH",
      "menu.openpgp": "OpenPGP",
      "menu.piv": "PIV",
      "menu.pass": "密码管理",
      "menu.ndef": "NFC标签",
      "menu.apdu": "APDU 控制台与历史",
      "menu.browserCheck": "浏览器兼容性",
      "menu.setupWizard": "配置向导",
      "menu.pinRecovery": "PIN恢复",
      "menu.compatibilityReport": "兼容性报告",

      // Overview - 概览
      "overview.title": "格里芬密钥 Web 控制台",
      "overview.device_status": "设备状态",
      "overview.connected": "已连接",
      "overview.disconnected": "未连接",
      "overview.model": "型号",
      "overview.serial": "序列号",
      "overview.chip_id": "芯片 ID",
      "overview.firmware": "固件版本",
      "overview.quick_nav": "快速导航",
      "overview.go_to": "前往",
      
      // Admin - 管理
      "admin.title": "管理",
      "admin.authentication": "认证",
      "admin.pin": "PIN码",
      "admin.change_pin": "修改PIN",
      "admin.storage": "存储",
      "admin.led": "LED",
      "admin.ndef": "NDEF",
      "admin.webusb": "WebUSB",
      "admin.reset": "重置",
      "admin.firmware_update": "固件更新",
      
      // FIDO2
      "fido2.title": "FIDO2",
      "fido2.credentials": "凭据",
      "fido2.pin_management": "PIN管理",
      
      // OATH
      "oath.title": "OATH",
      "oath.add_credential": "添加凭据",
      "oath.credentials": "凭据",
      
      // OpenPGP
      "openpgp.title": "OpenPGP",
      "openpgp.key_management": "密钥管理",
      
      // PIV
      "piv.title": "PIV",
      "piv.certificate": "证书",
      "piv.key_management": "密钥管理",
      
      // PASS - 密码管理
      "pass.title": "PASS - 密码管理器",
      "pass.description": "配置触摸按钮以自动输入密码。支持两个槽位：短按和长按。",
      "pass.short_press": "短按",
      "pass.long_press": "长按",
      "pass.slot": "槽位",
      "pass.type": "槽位类型",
      "pass.type.disabled": "禁用",
      "pass.type.static": "静态密码",
      "pass.type.oath": "OATH（动态）",
      "pass.password": "密码",
      "pass.credential": "凭据",
      "pass.auto_enter": "自动回车",
      "pass.auto_enter_help": "输入后自动按回车键",
      "pass.configure_slot": "配置{{slot}}槽位",
      "pass.reset": "重置 PASS",
      "pass.reset_confirm": "确定要重置 PASS 应用吗？这将清除所有密码槽位。",
      "pass.password_hidden": "••••••••",
      "pass.max_length": "最多 {{length}} 个字符",
      
      // NDEF - NFC标签
      "ndef.title": "NDEF - NFC 数据交换",
      "ndef.description": "管理 NFC NDEF 消息和标签。配置设备通过 NFC 广播的数据。",
      "ndef.current_message": "当前 NDEF 消息",
      "ndef.message_type": "消息类型",
      "ndef.url": "URL",
      "ndef.text": "文本",
      "ndef.custom": "自定义",
      "ndef.readonly": "只读",
      "ndef.readonly_help": "启用后，NDEF 数据无法修改",
      "ndef.message_content": "消息内容",
      "ndef.url_address": "URL 地址",
      "ndef.text_content": "文本内容",
      "ndef.language": "语言",
      "ndef.encoding": "编码",
      "ndef.hex_data": "十六进制数据",
      "ndef.write_message": "写入 NDEF 消息",
      "ndef.read_message": "读取 NDEF 消息",
      "ndef.reset": "重置 NDEF",
      "ndef.reset_confirm": "确定要重置 NDEF 吗？这将恢复默认 NFC 数据。",
      "ndef.max_size": "最大消息大小：1022 字节",
      "ndef.current_size": "当前大小：{{size}} 字节",
      
      // Messages - 消息提示
      "msg.device_not_connected": "设备未连接",
      "msg.please_connect": "请先连接您的设备",
      "msg.operation_success": "操作成功完成",
      "msg.operation_failed": "操作失败",
      "msg.invalid_input": "输入无效",
      "msg.confirm_action": "确定要继续吗？",

      // WebUSB
      "webusb.notSupported": "您的浏览器不支持 WebUSB。请使用 Chrome、Edge 或 Opera 浏览器。",
      "webusb.supported": "您的浏览器支持 WebUSB，可以正常使用！",
      "webusb.viewDetails": "查看详情",
      "webusb.downloadChrome": "下载 Chrome",

      // Browser Compatibility Check - 浏览器兼容性检测
      "browserCheck.title": "浏览器兼容性检测",
      "browserCheck.status.supported": "✓ 浏览器支持 WebUSB",
      "browserCheck.status.notSupported": "✗ 浏览器不支持 WebUSB",
      "browserCheck.status.supportedDesc": "您的浏览器支持 WebUSB API，可以正常使用所有功能。",
      "browserCheck.status.notSupportedDesc": "您的浏览器不支持 WebUSB API，无法连接 USB 设备。请使用推荐的浏览器。",
      "browserCheck.currentBrowser": "当前浏览器信息",
      "browserCheck.browserName": "浏览器",
      "browserCheck.browserVersion": "版本",
      "browserCheck.support": "支持",
      "browserCheck.supported": "支持",
      "browserCheck.notSupported": "不支持",
      "browserCheck.supportedBrowsers": "支持的浏览器",
      "browserCheck.recommended": "推荐",
      "browserCheck.download": "下载",
      "browserCheck.chrome.version": "版本 61 及以上（推荐）",
      "browserCheck.edge.version": "版本 79 及以上",
      "browserCheck.opera.version": "版本 48 及以上",
      "browserCheck.firefox.reason": "不支持（Mozilla 官方立场：反对）",
      "browserCheck.safari.reason": "不支持（Apple 官方立场：反对）",
      "browserCheck.whyNotSupported.title": "为什么 Firefox 和 Safari 不支持 WebUSB？",
      "browserCheck.whyNotSupported.security": "安全考虑：WebUSB 允许网页直接访问 USB 设备，存在潜在安全风险",
      "browserCheck.whyNotSupported.privacy": "隐私问题：可能被用于设备指纹识别和用户追踪",
      "browserCheck.whyNotSupported.architecture": "架构限制：与浏览器的安全模型存在冲突",
      "browserCheck.requirements.title": "WebUSB 使用要求",
      "browserCheck.requirements.https": "必须使用 HTTPS（安全上下文）",
      "browserCheck.requirements.userGesture": "需要用户手势才能发起连接",
      "browserCheck.requirements.devicePermission": "用户必须授予设备访问权限",

      // Common actions - 通用操作
      "common.back": "返回",
      "common.next": "下一步",

      // Setup Wizard - 配置向导
      "setupWizard.title": "配置向导",
      "setupWizard.step1": "设备检测",
      "setupWizard.step2": "PIN设置",
      "setupWizard.step3": "功能选择",
      "setupWizard.step4": "测试",
      "setupWizard.step5": "完成",
      "setupWizard.welcome": "欢迎使用配置向导",
      "setupWizard.welcomeDesc": "本向导将引导您在5分钟内完成设备的初始配置。",
      "setupWizard.whatYouNeed": "您需要准备",
      "setupWizard.need1": "通过USB连接的设备",
      "setupWizard.need2": "5分钟时间",
      "setupWizard.need3": "恢复码卡片（用于记录恢复码）",
      "setupWizard.deviceReady": "设备已检测并准备就绪",
      "setupWizard.setupPins": "设置PIN码",
      "setupWizard.pinsDesc": "设置用户PIN和管理员PIN以保护您的设备。",
      "setupWizard.userPinSection": "用户PIN",
      "setupWizard.userPin": "用户PIN",
      "setupWizard.confirmUserPin": "确认用户PIN",
      "setupWizard.userPinHelper": "6-8位数字，用于日常使用",
      "setupWizard.adminPinSection": "管理员PIN",
      "setupWizard.adminPin": "管理员PIN",
      "setupWizard.confirmAdminPin": "确认管理员PIN",
      "setupWizard.adminPinHelper": "8位数字，用于设备管理",
      "setupWizard.selectFeatures": "选择功能",
      "setupWizard.featuresDesc": "选择要在设备上启用的功能。",
      "setupWizard.recommended": "推荐",
      "setupWizard.fido2Desc": "用于网站双因素认证",
      "setupWizard.pivDesc": "用于企业身份认证和Windows登录",
      "setupWizard.openpgpDesc": "用于邮件加密和代码签名",
      "setupWizard.oathDesc": "用于生成验证码",
      "setupWizard.testing": "测试设备",
      "setupWizard.testingDesc": "运行测试以确保一切正常工作。",
      "setupWizard.testUsb": "USB通信测试",
      "setupWizard.testNfc": "NFC功能测试",
      "setupWizard.testFido2": "FIDO2功能测试",
      "setupWizard.testPiv": "PIV智能卡测试",
      "setupWizard.testOpenPGP": "OpenPGP功能测试",
      "setupWizard.testOath": "OATH (TOTP/HOTP) 测试",
      "setupWizard.complete": "配置完成！",
      "setupWizard.completeDesc": "您的设备现在可以使用了。",
      "setupWizard.nextSteps": "下一步",
      "setupWizard.next1": "将设备添加到网站（Google、GitHub等）",
      "setupWizard.next2": "记下恢复码并妥善保管",
      "setupWizard.next3": "在控制台中探索其他功能",
      "setupWizard.runTests": "运行测试",
      "setupWizard.error.noDevice": "未连接设备",
      "setupWizard.error.deviceCheck": "检查设备失败",
      "setupWizard.error.invalidUserPin": "用户PIN必须是6-8位数字",
      "setupWizard.error.userPinMismatch": "用户PIN不匹配",
      "setupWizard.error.invalidAdminPin": "管理员PIN必须是8位数字",
      "setupWizard.error.adminPinMismatch": "管理员PIN不匹配",
      "setupWizard.error.samePins": "用户PIN和管理员PIN必须不同",
      "setupWizard.error.pinSetup": "设置PIN失败",
      "setupWizard.error.wrongPin": "PIN错误，还剩{{retries}}次重试机会",
      "setupWizard.error.pinBlocked": "PIN已被锁定",
      "setupWizard.error.defaultPinFailed": "默认PIN验证失败 - 设备可能已经初始化过",
      "setupWizard.error.adminPinChangeFailed": "修改管理员PIN失败",
      "setupWizard.error.featureConfig": "配置功能失败",
      "setupWizard.error.tests": "测试失败",
      "setupWizard.error.usbTestFailed": "USB通信测试失败 - 请检查设备连接",
      "setupWizard.error.fido2TestFailed": "FIDO2测试失败 - 应用可能未启用",
      "setupWizard.error.pivTestFailed": "PIV测试失败 - 应用可能未启用",
      "setupWizard.error.openpgpTestFailed": "OpenPGP测试失败 - 应用可能未启用",
      "setupWizard.error.oathTestFailed": "OATH测试失败 - 应用可能未启用",
      "setupWizard.error.deviceDisconnected": "设备已断开连接 - 请重新连接并重新开始",
      "setupWizard.deviceDetected": "设备检测成功",
      "setupWizard.pinsSet": "PIN设置成功",
      "setupWizard.autoLoginSuccess": "已使用新PIN自动登录",
      "setupWizard.featuresConfigured": "功能配置成功",
      "setupWizard.testsComplete": "所有测试通过",
      "setupWizard.deviceAutoConnected": "设备已自动连接",
      "setupWizard.deviceConnected": "设备已连接 - 可以继续",
      "setupWizard.noDeviceHint": "未检测到设备。点击\"下一步\"选择并连接您的设备。",
      "setupWizard.defaultPinDetected": "设备正在使用默认PIN - 请设置您的自定义PIN",
      "setupWizard.alreadyInitialized": "设备似乎已经初始化过。如果继续，将覆盖现有的PIN。",

      // Overview - 概览
      "overview.setupWizardTitle": "需要首次设置",
      "overview.setupWizardMessage": "您的设备正在使用默认PIN（123456）。出于安全考虑，强烈建议立即更改。",
      "overview.setupWizardWarning": "默认PIN是公开的，会使您的设备容易受到未经授权的访问。",
      "overview.setupNow": "立即设置",
      "overview.setupLater": "稍后提醒",
      "overview.setupLaterReminder": "请尽快更改您的PIN以确保安全",

      // PIN Recovery - PIN恢复
      "pinRecovery.title": "PIN恢复",
      "pinRecovery.step1": "介绍",
      "pinRecovery.step2": "检查状态",
      "pinRecovery.step3": "重置PIN",
      "pinRecovery.step4": "完成",
      "pinRecovery.welcome": "欢迎使用PIN恢复",
      "pinRecovery.welcomeDesc": "此工具帮助您使用恢复码重置PIN。",
      "pinRecovery.warning": "警告：恢复码只能使用一次。使用后，您必须生成新的恢复码。",
      "pinRecovery.requirements": "要求：",
      "pinRecovery.req1": "通过USB连接的设备",
      "pinRecovery.req2": "8位字符的恢复码",
      "pinRecovery.req3": "新的PIN码（6-8位数字）",
      "pinRecovery.statusCheck": "恢复码状态",
      "pinRecovery.currentStatus": "当前状态",
      "pinRecovery.status.unused": "可用（可以使用）",
      "pinRecovery.status.used": "已使用（需要生成新码）",
      "pinRecovery.status.locked": "已锁定（尝试次数过多）",
      "pinRecovery.canProceed": "恢复码可用。您可以继续重置PIN。",
      "pinRecovery.codeUsed": "恢复码已使用。请先生成新的恢复码。",
      "pinRecovery.codeLocked": "恢复码因失败尝试过多而被锁定。请联系支持。",
      "pinRecovery.enterDetails": "输入恢复详情",
      "pinRecovery.pinType": "PIN类型",
      "pinRecovery.userPin": "用户PIN",
      "pinRecovery.adminPin": "管理员PIN",
      "pinRecovery.recoveryCode": "恢复码",
      "pinRecovery.codeHelper": "恢复卡片上的8位字符",
      "pinRecovery.newPin": "新PIN",
      "pinRecovery.confirmPin": "确认新PIN",
      "pinRecovery.pinHelper": "6-8位数字",
      "pinRecovery.resetWarning": "重置后，您必须立即生成新的恢复码。",
      "pinRecovery.resetPin": "重置PIN",
      "pinRecovery.complete": "PIN重置完成！",
      "pinRecovery.completeDesc": "您的PIN已成功重置。",
      "pinRecovery.nextSteps": "重要的下一步",
      "pinRecovery.next1": "立即生成新的恢复码",
      "pinRecovery.next2": "将新恢复码写在卡片上",
      "pinRecovery.next3": "测试新PIN以确保其有效",
      "pinRecovery.resetAnother": "重置另一个PIN",
      "pinRecovery.help": "帮助",
      "pinRecovery.q1": "问：如果我丢失了恢复码怎么办？",
      "pinRecovery.a1": "答：不幸的是，没有恢复码，您无法重置PIN。您需要重置整个设备，这将清除所有数据。",
      "pinRecovery.q2": "问：我可以多次使用同一个恢复码吗？",
      "pinRecovery.a2": "答：不可以，每个恢复码只能使用一次。使用后，您必须生成新的。",
      "pinRecovery.q3": "问：如何生成新的恢复码？",
      "pinRecovery.a3": "答：转到管理部分并选择'生成恢复码'。",
      "pinRecovery.error.noDevice": "未连接设备",
      "pinRecovery.error.checkFailed": "检查恢复码状态失败",
      "pinRecovery.error.invalidCode": "恢复码必须是8位字符",
      "pinRecovery.error.invalidPin": "PIN必须是6-8位数字",
      "pinRecovery.error.pinMismatch": "PIN不匹配",
      "pinRecovery.error.invalidCodeOrUsed": "无效的恢复码或已使用",
      "pinRecovery.error.resetFailed": "重置PIN失败",
      "pinRecovery.success": "PIN重置成功",

      // Compatibility Report - 兼容性报告
      "compatibility.title": "提交兼容性报告",
      "compatibility.description": "通过分享您的网站和服务使用体验来帮助其他用户。",
      "compatibility.websiteInfo": "网站信息",
      "compatibility.websiteName": "网站名称",
      "compatibility.websiteUrl": "网站URL",
      "compatibility.category": "类别",
      "compatibility.supportStatus": "支持状态",
      "compatibility.support": "支持",
      "compatibility.full": "完全支持",
      "compatibility.partial": "部分支持",
      "compatibility.none": "不支持",
      "compatibility.yes": "是",
      "compatibility.no": "否",
      "compatibility.unknown": "未知",
      "compatibility.testResult": "测试结果",
      "compatibility.testResultLabel": "是否正常工作？",
      "compatibility.working": "正常工作",
      "compatibility.notWorking": "无法工作",
      "compatibility.partialWork": "部分工作",
      "compatibility.issues": "遇到的问题",
      "compatibility.issuesPlaceholder": "描述您遇到的任何问题...",
      "compatibility.setupSteps": "配置步骤",
      "compatibility.setupStepsPlaceholder": "1. 转到...\n2. 点击...\n3. ...",
      "compatibility.environment": "设备和环境",
      "compatibility.deviceModel": "设备型号",
      "compatibility.browserVersion": "浏览器和版本",
      "compatibility.notes": "附加说明",
      "compatibility.notesPlaceholder": "任何其他可能有帮助的信息...",
      "compatibility.submit": "提交报告",
      "compatibility.tips": "提交提示",
      "compatibility.tip1": "具体说明您遵循的步骤",
      "compatibility.tip2": "包含您看到的任何错误消息",
      "compatibility.tip3": "如果相关，请提及您的操作系统",
      "compatibility.thankYou": "谢谢！",
      "compatibility.submitted": "您的兼容性报告已成功提交。",
      "compatibility.error.required": "请填写所有必填字段",
      "compatibility.error.submit": "提交报告失败",
      "compatibility.success": "报告提交成功",
    }
  }
};

i18n
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 传递 i18n 实例到 react-i18next
  .init({
    resources,
    lng: 'en', // 强制默认语言为英文
    fallbackLng: 'en', // 回退语言
    debug: false,

    interpolation: {
      escapeValue: false // React 已经处理了 XSS
    },

    detection: {
      // 语言检测顺序：仅从 localStorage 读取，不使用浏览器语言
      order: ['localStorage'],
      caches: ['localStorage'],
    }
  });

export default i18n;

